export const modalsInitialState = {
  signUp: false,
  signIn: false,
  orderCompletionModal: false,
};

export const modalsReducer = (state, action) => {
  switch (action.type) {
    case "OPEN_SIGN_UP":
      return {
        signUp: true,
        state,
      };
    case "OPEN_SIGN_IN":
      return {
        signIn: true,
        state,
      };
    case "CLOSE_SIGN_UP":
      return {
        signUp: false,
        state,
      };
    case "CLOSE_SIGN_IN":
      return {
        signIn: false,
        state,
      };
    case "OPEN_ORDER_COMPLETION_MODAL":
      return {
        orderCompletionModal: true,
        state,
      };
    case "CLOSE_ORDER_COMPLETION_MODAL":
      return {
        orderCompletionModal: false,
        state,
      };

    default:
      break;
  }
};
